import React, { Component } from "react"
import { utils } from "../constants"


/* Card suit symbols as inline SVG (red hearts/diamonds, white clubs/spades) */
const SUIT_PATH = {
    heart: "M12 21s-8.4-5.7-8.4-11.4A4.4 4.4 0 0 1 12 6.2a4.4 4.4 0 0 1 8.4 3.4C20.4 15.3 12 21 12 21z",
    diamond: "M12 2l7.2 10L12 22 4.8 12z",
    spade: "M12 2C9 6 3.6 9.6 3.6 14a4.2 4.2 0 0 0 6.8 3.2C10.1 19.2 9.2 20.3 8 21h8c-1.2-.7-2.1-1.8-2.4-3.8A4.2 4.2 0 0 0 20.4 14C20.4 9.6 15 6 12 2z",
}


/* ONE BLACKJACK payout data (info + combinations from eb1-front) */
const MAIN = [
    { name: "BEST HAND", value: "1:1" },
    { name: "INSURANCE", value: "2:1" },
    { name: "EVEN MONEY", value: "1:1" },
    { name: "BLACKJACK", value: "3:2" },
]

const PERFECT_PAIR = [
    { name: "PERFECT PAIR", value: "25:1", combo: [{ r: "K", s: "diamond" }, { r: "K", s: "diamond" }] },
    { name: "COLOURED PAIR", value: "12:1", combo: [{ r: "K", s: "heart" }, { r: "A", s: "diamond" }] },
    { name: "MIXED PAIR", value: "6:1", combo: [{ r: "Q", s: "club" }, { r: "Q", s: "heart" }] },
]

const TWENTY_ONE = [
    { name: "SUITED TRIPS", value: "100:1", combo: [{ r: "A", s: "spade" }, { r: "A", s: "spade" }, { r: "A", s: "spade" }] },
    { name: "STRAIGHT FLUSH", value: "40:1", combo: [{ r: "7", s: "heart" }, { r: "8", s: "heart" }, { r: "9", s: "heart" }] },
    { name: "THREE OF A KIND", value: "30:1", combo: [{ r: "Q", s: "club" }, { r: "Q", s: "diamond" }, { r: "Q", s: "spade" }] },
    { name: "STRAIGHT", value: "10:1", combo: [{ r: "3", s: "spade" }, { r: "4", s: "diamond" }, { r: "5", s: "heart" }] },
    { name: "FLUSH", value: "5:1", combo: [{ r: "3", s: "heart" }, { r: "10", s: "heart" }, { r: "Q", s: "heart" }] },
]

const BUST_BONUS = [
    { name: "BUST WITH 8+ CARDS", value: "250:1" },
    { name: "BUST WITH 7 CARDS", value: "100:1" },
    { name: "BUST WITH 6 CARDS", value: "50:1" },
    { name: "BUST WITH 5 CARDS", value: "9:1" },
    { name: "BUST WITH 4 CARDS", value: "2:1" },
    { name: "BUST WITH 3 CARDS", value: "1:1" },
]

const CRAZY_SEVEN = [
    { name: "7-7-7 SUITED", value: "2000:1", combo: [{ r: "7", s: "heart" }, { r: "7", s: "heart" }, { r: "7", s: "heart" }] },
    { name: "7-7-7", value: "500:1", combo: [{ r: "7", s: "club" }, { r: "7", s: "diamond" }, { r: "7", s: "spade" }] },
    { name: "7-7 SUITED", value: "150:1", combo: [{ r: "7", s: "diamond" }, { r: "7", s: "diamond" }] },
    { name: "7-7", value: "25:1", combo: [{ r: "7", s: "spade" }, { r: "7", s: "heart" }] },
    { name: "7", value: "5:1", combo: [{ r: "7", s: "club" }] },
]


/* Component Payout (styled after uvp-front GamePayout) */
class GamePayout extends Component {

    /* Section limits (min - side max) */
    minmax = (key) => {
        const { min, max, currency } = this.props
        const value = key === "main" ? max : utils.betMax(key, max)
        return <span className="minmax">&nbsp;&nbsp;{utils.convertor(min, currency)} - {utils.convertor(value, currency)}</span>
    }

    /* Inline SVG suit (club drawn from circles + stem) */
    _suit = (s) => {

        const red = s === "heart" || s === "diamond"
        const color = red ? "#d0021b" : "#fff"

        if (s === "club") {
            return (
                <svg viewBox="0 0 24 24" className="game-payout--suit" aria-hidden="true">
                    <g fill={color}>
                        <circle cx="12" cy="7" r="3.4" />
                        <circle cx="7.4" cy="13" r="3.4" />
                        <circle cx="16.6" cy="13" r="3.4" />
                        <path d="M10.6 12h2.8l1.3 9h-5.4z" />
                    </g>
                </svg>
            )
        }

        return (
            <svg viewBox="0 0 24 24" className="game-payout--suit" aria-hidden="true">
                <path fill={color} d={SUIT_PATH[s]} />
            </svg>
        )
    }

    /* One combination (rank + suit cards) */
    _combo = (combo) => (
        combo.map((c, index) =>
            <span className="game-payout--card" key={`${index}`}>
                <span className="game-payout--rank">{c.r}</span>
                {this._suit(c.s)}
            </span>
        )
    )

    /* One payout group: header row + item rows */
    _group = (title, key, items) => (
        <>
            <div className="row">
                <p>{title}</p>
                <p>{this.minmax(key)}</p>
            </div>
            <div className="combinations">
                {items.map((item, index) =>
                    <div className="item" key={`${index}`}>
                        <p>{item.name}</p>
                        <div className="item-combo">{item.combo ? this._combo(item.combo) : null}</div>
                        <p className="result">{item.value}</p>
                    </div>
                )}
            </div>
        </>
    )

    render = () => {
        return (
            <div className="game-payout">
                {this._group("ОСНОВНАЯ", "main", MAIN)}
                {this._group("PERFECT PAIRS", "perfectPair", PERFECT_PAIR)}
                {this._group("21+3", "twentyone", TWENTY_ONE)}
                {this._group("BUST BONUS", "bustBonus", BUST_BONUS)}
                {this._group("CRAZY 7", "crazySeven", CRAZY_SEVEN)}
            </div>
        )
    }
}

export default GamePayout
